import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  TableFooter,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  useGetDepositInfoQuery,
  useRemoveDepositInfoMutation,
} from "../../../features/api/depositApi";
import { toast } from "react-toastify";

const BankDeposit = () => {
  const { data, error, isLoading } = useGetDepositInfoQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const bankDeposits = data?.bankdeposits;

  const [removeDepositInfo] = useRemoveDepositInfoMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeDepositInfo(id);
        if (result) {
          toast.success("Delete Success...!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredResults = bankDeposits?.filter((item) =>
      item?.bankName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  const total = bankDeposits?.reduce((sum, amt) => sum + +amt?.depositAmt, 0);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <div className="flex justify-between items-center px-12 my-4">
        <h1 className="text-xl font-bold">Bank Deposit</h1>
        <button className="px-2 py-1 bg-green-950 text-white font-bold rounded-sm">
          <Link to="/dashboard/bankdeposit-create">Create</Link>
        </button>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : bankDeposits?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no Deposit information
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Account Name</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Account No</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Deposit Amount</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Deposit Status</span>
                  </TableCell>

                  <TableCell>
                    <span className="font-bold">Dealer</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Clearing Date</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Supplier</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchTerm
                  ? searchResults
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => (
                        <TableRow key={row.id}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{row.accName}</TableCell>
                          <TableCell>{row.accNo}</TableCell>
                          <TableCell>{row.depositAmt}</TableCell>
                          <TableCell>{row.depositStatus}</TableCell>
                          <TableCell>{row.dealer}</TableCell>
                          <TableCell>{formatDate(row.clearingDate)}</TableCell>
                          <TableCell>{row.supplier}</TableCell>
                          <TableCell className="">
                            <div className="flex items-center gap-x-4">
                              <span onClick={() => handleDelete(row?.id)}>
                                <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                  : bankDeposits
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => (
                        <TableRow key={row.id}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{row.accName}</TableCell>
                          <TableCell>{row.accNo}</TableCell>
                          <TableCell>{row.depositAmt}</TableCell>
                          <TableCell>{row.depositStatus}</TableCell>
                          <TableCell>{row.dealer}</TableCell>
                          <TableCell>{formatDate(row.clearingDate)}</TableCell>
                          <TableCell>{row.supplier}</TableCell>
                          <TableCell className="">
                            <div className="flex items-center gap-x-4">
                              <span onClick={() => handleDelete(row?.id)}>
                                <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
              </TableBody>
              <TableFooter>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell colSpan={4}>
                  <span className="font-bold">{total}/-</span>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                {/* <TableCell ></TableCell>
              <TableCell ></TableCell>
              <TableCell ></TableCell>
              <TableCell ></TableCell> */}
              </TableFooter>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component="div"
              count={bankDeposits?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default BankDeposit;